import { api } from "api";

export const getEmployeeRoles = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/employee-role/get-roles-of-employees")
      .then((res) => {
        dispatch({
          type: "GET_ROLES_OF_EMPLOYEES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_ROLES_OF_EMPLOYEES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const createEmployeeRole = (
  employeeId,
  roleId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/employee-role/create-employee-role", {
        employeeId: employeeId,
        roleId: roleId,
      })
      .then((res) => {
        dispatch({
          type: "CREATE_EMPLOYEE_ROLE_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "CREATE_EMPLOYEE_ROLE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const cancelEmployeeRole = (
  employeeRoleId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/employee-role/cancel-employee-role", {
        employeeRoleId: employeeRoleId,
      })
      .then((res) => {
        dispatch({
          type: "CREATE_EMPLOYEE_ROLE_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "CREATE_EMPLOYEE_ROLE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
